import { Info } from "lucide-react";
import { Tooltip } from "../arc/components/tooltip/tooltip";
import { Button } from "../arc/components/button/button";
import styles from "./InfoTooltip.module.css";

/**
 * A small info glyph that reveals Arc tooltip copy on hover or keyboard focus.
 * Use it beside any card header, metric label or control whose meaning isn't
 * self-evident, so unfamiliar numbers and actions explain themselves in place.
 */
export default function InfoTooltip({
  label,
  content,
  side = "top",
  size = 13,
  className = "",
}) {
  return (
    <Tooltip content={content} side={side}>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={`${styles.trigger} axo-info-tip ${className}`.trim()}
        aria-label={label}
        onClick={(event) => event.stopPropagation()}
      >
        <Info size={size} strokeWidth={2} aria-hidden="true" />
      </Button>
    </Tooltip>
  );
}
